import {useLoaderData} from "react-router-dom";
import {calendar_object} from '../../datasets/calendarobjects';
import MobileUpBar from "../../components/mobileUpBar";
import ArrowBackOutlined from "@mui/icons-material/ArrowBackOutlined";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";
import {useState} from "react";
import {
    format,
    startOfMonth,
    isEqual,
    endOfMonth,
    startOfWeek,
    endOfWeek,
    eachDayOfInterval,
    isWithinInterval,
    parse,
    addMonths,
    parseISO,
    isSameDay
} from 'date-fns';
import {uk} from "date-fns/locale";
import {Box, Grid, IconButton, Typography} from "@mui/material";
import '../styles.css';
import api from "../../hooks/useApi";
import PageTitle from "../../components/PageTitle";


export async function loader({request, params}) {
    const id = params.object_id;
    const object_ = (await api.get(`/api/HotelObj/${id}/`))
    return {id, object_};
}

export default function ObjectSingle() {
    const [month, setMonth] = useState(new Date());
    const {id, object_} = useLoaderData();
    const monthStart = startOfMonth(month);
    const monthEnd = endOfMonth(month);
    const startWeek = startOfWeek(monthStart, {weekStartsOn: 1});
    const endWeek = endOfWeek(monthEnd, {weekStartsOn: 1});

    const days = eachDayOfInterval({start: startWeek, end: endWeek});

    const isInRange = (day, start, end) => {
        return isWithinInterval(day, {start: start, end: end});
    };
    //add checker FOR EACH object (hotel children)
    const isInRangeBooking = (day) => {
        if (!Array.isArray(object_.bookings) || object_.bookings.length === 0) {
            return ''; // возвращаем пустую строку, если массив пуст или не является массивом
        }
        for (let el of object_.bookings) {
            const startF = parseISO(el.booking_from);
            const endF = parseISO(el.booking_to);
            if (isSameDay(day, startF)) {
                return 'start_segment';
            } else if (isSameDay(day, endF)) {
                return 'end_segment';
            } else if (isWithinInterval(day, {start: startF, end: endF})) {
                return 'between_segment';
            }
        }
        return '';
    };
    const getWeeks = (days) => {
        const weeks = [];
        let currentWeek = [];

        days.forEach((day, index) => {
            currentWeek.push(day);
            if ((index + 1) % 7 === 0) {
                weeks.push(currentWeek);
                currentWeek = [];
            }
        });

        if (currentWeek.length > 0) {
            weeks.push(currentWeek);
        }

        return weeks;
    };

    const weeks = getWeeks(days);
    return (
        <>
            <PageTitle title={`Календар об'єкта: ${object_?.name || id}`} />
            <MobileUpBar
                middleElement={<div>{format(month, 'yyyy', {locale: uk})}</div>}
            />
            <Box style={{display: 'flex', flexDirection: 'row', flexGrow: 1}}>
                <IconButton onClick={() => setMonth(prev => addMonths(prev, -1))}>
                    <ArrowBackOutlined/>
                </IconButton>
                <Box style={{flexGrow: 1, display: 'flex', justifyContent: 'center'}}>
                    {format(month, 'LLLL', {locale: uk})}
                </Box>
                <IconButton onClick={() => setMonth(prev => addMonths(prev, 1))}>
                    <ArrowForwardOutlined/>
                </IconButton>
            </Box>
            <Grid container sx={{justifyContent: 'center'}} spacing={0.5}>
                {Array(1).fill('a').map((el, index) => (
                    <Grid item xs={6} key={index}>
                        <table className='mobile' style={{border: 'none'}}>
                            <thead>
                            <tr>
                                {['П', 'В', 'С', 'Ч', 'П', 'С', 'Н'].map((day, index) => (
                                    <th key={index} style={{textAlign: 'center'}}>
                                        <Typography variant="body2">{day}</Typography>
                                    </th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {weeks.map((week, weekIndex) => (
                                <tr key={weekIndex}>
                                    {week.map((day, dayIndex) => (
                                        <td key={dayIndex}
                                            style={{
                                                maxWidth: `${100 / 7}%`,
                                                minWidth: `${100 / 7}%`,
                                                textAlign: 'center',
                                                padding: '1px'
                                            }}
                                            className={`${isInRangeBooking(day)} selectable`}>
                                            {isInRange(day, monthStart, monthEnd) && (
                                                <Box
                                                    sx={{
                                                        height: '40px',
                                                        lineHeight: '40px'
                                                    }}
                                                >
                                                    <Typography variant="body2" color='textPrimary'>
                                                        {format(day, 'dd')}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </Grid>))}
            </Grid>
        </>
    )
}
